import { render, staticRenderFns } from "./explaur.vue?vue&type=template&id=15067111&scoped=true"
import script from "./explaur.vue?vue&type=script&lang=js"
export * from "./explaur.vue?vue&type=script&lang=js"
import style0 from "./explaur.vue?vue&type=style&index=0&id=15067111&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15067111",
  null
  
)

export default component.exports